import { render, staticRenderFns } from "./SearchCustomer.vue?vue&type=template&id=3ef5ca5f&scoped=true"
import script from "./SearchCustomer.vue?vue&type=script&lang=js"
export * from "./SearchCustomer.vue?vue&type=script&lang=js"
import style0 from "./SearchCustomer.vue?vue&type=style&index=0&id=3ef5ca5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef5ca5f",
  null
  
)

export default component.exports